module.exports = __webpack_public_path__ + "static/19-money-bag 1-3da899f96cb504c314294ffd94efe2c2.svg";